<template>
    <div>
        <b-modal
            ref="modalList"
            hide-footer
            :title="titleModal"
            size="lg"
            no-close-on-backdrop
            hide-header-close
            hide-header
            >
            <div class="title-modal">
            <div class="title-text-modal">{{ titleModal }}</div>
            <div
                class="float-right btn-hover-modal"
                @click="closeModal()"
            >
                <xIcon/>
            </div>
            </div>
            <div class="modal-edicao mb-5 modal-edicao-label mt-6">
                <DataTable
                    class="data-table"
                    :nofilters="true"
                    :async="true"
                    :nosearch="false"
                    :hideBtnAdd="false"
                    :linhas="linhas"
                    :colunas="colunas"
                    :noedit="true"
                    :errMsg="errMsg"
                    :state="{
                        sortBy: sortTable.sortBy,
                        sortAsc: sortTable.order === 1,
                        query: ''
                    }"
                    @state-change="(state) => newSearch(state)"
                    :loading="loading"
                    @clickBtnAdd="clickBtnAdd"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
	import DataTable from "@/components/DataTable.vue";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { formatIdentityDocument } from "@/helpers/validateIndentity";
	import emitter from "@/eventBus.js";
	import { CustomerService } from "@/services/customer";

	export default {
		components: {
			DataTable
		},

		props: {
			titleModal: {
				type: String,
				required: false,
				default: "Pesquisar"
			},
			errMsg: {
				type: String,
				required: false,
				default: "Nenhuma consulta reealizada"
			},
			colunas: {
				type: Array,
				required: true
			}
		},

		inject: ["parentValidator"],

		data () {
			return {
				formatIdentityDocument,
				customerService: new CustomerService(),
				loading: false,
				linhas: [],
				pagination: {
					count: 0,
					page: 1,
					offset: 0,
					limit: {
						value: 50
					},
					pages: 1
				},
				sortTable: {
					sortBy: 1,
					order: 1,
					query: ""
				}
			};
		},

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);
			this.showCustomer();
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},
			showCustomer () {
				this.$refs.modalList.show();
			},

			closeModal () {
				this.$refs.modalList.hide();
				this.$emit("closeModal");
			},
			newSearch (state) {
				this.sortTable.query = state.query;
				this.findCustomer();
			},
			clickBtnAdd () {
				this.$emit("clickBtnAdd");
			},

			formatDocumentSelected () {
				//this.customerSelected.identityDocument = formatIdentityDocument(this.customerSelected.identityDocument);
			},

			async findCustomer () {
				this.loading = true;
				const limit = this.pagination.limit.value;
				this.pagination.offset = (this.pagination.page - 1) * limit;
				const offset = this.pagination.offset;
				const sortTable = this.sortTable;
				const result = await this.customerService.listCustomer({ offset, limit, sortTable }) || {};
				this.customers = result.rows || [];

				this.linhas = result.rows.reduce((acc, customer) => [
					...acc,
					{
						idCustomer: customer.idCustomer,
						cols: [
							customer.identityDocument ? formatIdentityDocument(customer.identityDocument) : "",
							customer.name,
							customer.surname,
							customer.email,
							customer.cellPhone,
							customer.telephone
						]
					}
				], []);
				this.pagination.count = result.count || 0;
				this.pagination.pages = this.pagination.count > limit ? Math.ceil(this.pagination.count / limit) : 1;
				this.loading = false;
			}

		}
	};
</script>
